import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';

export enum LookupCodes {
  EMPTY = '',
  FORMAT = 'format',
  SIDE_TICKNESS = 'side-thickness',
  BORDER_TYPE = 'border-type',
  FRAME_COLOR = 'frame-color',
  LAYOUT = 'layout',
  FRONT_SURFACE = 'front-surface',
  PASSEPARTOUT = 'passepartout',
  PASSEPARTOUT_COLOR = 'passepartout-color',
  PASSEPARTOUT_TYPE = 'passepartout-type',
  CORRECTION = 'correction',
  SIDE_COLOR = 'side-color',
  PAPER = 'paper',
  VARIABLE = 'variable',
  PAPER_COLOR = 'paper_color',
  TEXT = 'text',
  BOXSTYLE = 'boxstyle',
  PRINT_TYPE = 'printtype',
  KIT_TYPE = 'kit-type',
}

export const LookupCodesWithVisibleDescriptions = [
  LookupCodes.FRONT_SURFACE,
  LookupCodes.CORRECTION,
  LookupCodes.BORDER_TYPE,
];

export const LookupCodesWithColorChoice = [LookupCodes.PAPER_COLOR, LookupCodes.PASSEPARTOUT];

export const LookupIconNamesMap: Partial<Record<LookupCodes, ICON_NAMES>> = {
  [LookupCodes.FORMAT]: ICON_NAMES.Ruler,
  [LookupCodes.FRAME_COLOR]: ICON_NAMES.FrameColor,
  [LookupCodes.LAYOUT]: ICON_NAMES.Layout,
  [LookupCodes.PAPER]: ICON_NAMES.PhotoPaper,
  [LookupCodes.FRONT_SURFACE]: ICON_NAMES.Glass,
  [LookupCodes.PASSEPARTOUT_COLOR]: ICON_NAMES.PassepartoutColor,
  [LookupCodes.PASSEPARTOUT]: ICON_NAMES.Border,
  [LookupCodes.PASSEPARTOUT_TYPE]: ICON_NAMES.Space,
  [LookupCodes.CORRECTION]: ICON_NAMES.AutoCorrection,
  [LookupCodes.SIDE_TICKNESS]: ICON_NAMES.Thickness,
  [LookupCodes.BORDER_TYPE]: ICON_NAMES.Edge,
  [LookupCodes.SIDE_COLOR]: ICON_NAMES.SideColor,
  [LookupCodes.PAPER_COLOR]: ICON_NAMES.Palette,
  [LookupCodes.TEXT]: ICON_NAMES.IconText,
  [LookupCodes.PRINT_TYPE]: ICON_NAMES.PrintType,
  [LookupCodes.KIT_TYPE]: ICON_NAMES.KitType,
};
